import { Text } from '@vallourec-ui/vallourec-ui'
import styled from 'styled-components'

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors['neutral-color-5']};
  width: 100%;
  align-self: stretch;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors['neutral-color-80']};
  min-height: 30rem;
  max-height: 50rem;
  padding-right: ${({ theme }) => theme.spacing[16]};
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: auto;
  width: 100%;
  margin-bottom: 1px;
  gap: 1.5rem;
`

export const ComponentsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`

export const StyledText = styled(Text)`
  padding-left: ${({ theme }) => theme.spacing[6]};
  padding-bottom: ${({ theme }) => theme.spacing[0]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontSize['text-sm']};
  margin-top: 6px;
  margin-bottom: 6px;
`

export const ComponentsSearchColumn = styled.div<{ isLast?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: ${(props) =>
    props.isLast ? '0' : ({ theme }) => theme.spacing[16]};
  margin-top: ${({ theme }) => theme.spacing[8]};
  margin-bottom: ${({ theme }) => theme.spacing[16]};

  > div button {
    width: auto;
  }
`
